const ThreeColumns = () => (
  <>
    <div className="py-12 bg-white ">
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        {/* <h2 className="sr-only">A better way to send money.</h2> */}
        <div className="text-left">
          <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase">
            INSTANT ACCOUNT OPENING
          </h2>
          <p className="text-left text-xl text-gray-500 lg:mx-auto">
            The most simplified trading account opening system in the market.
          </p>
        </div>
        <br />
        <br />
        <br />
        <dl className="space-y-10 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-8">
          <div>
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
              <p>01</p>
            </div>
            <div className="mt-5">
              <dd className="mt-2 text-base text-gray-500">
                Fill in our Registration form. We’ve prepared only the main
                fields we need to onboard you.
              </dd>
            </div>
          </div>

          <div>
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
              <p>02</p>
            </div>
            <div className="mt-5">
              <dd className="mt-2 text-base text-gray-500">
                Attach your documents and we will review them instantly.
              </dd>
            </div>
          </div>

          <div>
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
              03
            </div>
            <div className="mt-5">
              <dd className="mt-2 text-base text-gray-500">
                Deposit and Trade! Straight away after registration.
              </dd>
            </div>
          </div>
        </dl>
      </div>
    </div>
  </>
);

export default ThreeColumns;
